module.exports = __webpack_public_path__ + "img/homeSec01Top2.4a316570.jpg";